import {
  GET_EMPLOYEECONTRACT,
  GET_EMPLOYEECONTRACT_SUCCESS,
  GET_EMPLOYEECONTRACT_FAIL,
  DELETE_EMPLOYEECONTRACT,
  DELETE_EMPLOYEECONTRACT_SUCCESS,
  DELETE_EMPLOYEECONTRACT_FAIL,
  UPDATE_EMPLOYEECONTRACT,
  UPDATE_EMPLOYEECONTRACT_SUCCESS,
  UPDATE_EMPLOYEECONTRACT_FAIL,
  ADD_NEW_EMPLOYEECONTRACT,
  ADD_EMPLOYEECONTRACT_SUCCESS,
  ADD_EMPLOYEECONTRACT_FAIL,
  EMPLOYEECONTRACT_LOADING,
} from "./actionType";

export const getEmployeeContractSuccess = (actionType, data) => ({
  type: GET_EMPLOYEECONTRACT_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeContractFail = (actionType, error) => ({
  type: GET_EMPLOYEECONTRACT_FAIL,
  payload: { actionType, error },
});

export const getEmployeeContract = data => ({
  type: GET_EMPLOYEECONTRACT,
  payload: data,
});

export const getEmployeeContractLoading = () => ({
  type: EMPLOYEECONTRACT_LOADING
});

export const deleteEmployeeContract = data => ({
  type: DELETE_EMPLOYEECONTRACT,
  payload: data,
});

export const deleteEmployeeContractSuccess = data => ({
  type: DELETE_EMPLOYEECONTRACT_SUCCESS,
  payload: data,
});

export const deleteEmployeeContractFail = error => ({
  type: DELETE_EMPLOYEECONTRACT_FAIL,
  payload: error,
});

export const updateEmployeeContract = data => ({
  type: UPDATE_EMPLOYEECONTRACT,
  payload: data,
});

export const updateEmployeeContractFail = error => ({
  type: UPDATE_EMPLOYEECONTRACT_FAIL,
  payload: error,
});

export const updateEmployeeContractSuccess = data => ({
  type: UPDATE_EMPLOYEECONTRACT_SUCCESS,
  payload: data,
});

export const addNewEmployeeContract = data => ({
  type: ADD_NEW_EMPLOYEECONTRACT,
  payload: data,
});

export const addEmployeeContractSuccess = data => ({
  type: ADD_EMPLOYEECONTRACT_SUCCESS,
  payload: data,
});

export const addEmployeeContractFail = error => ({
  type: ADD_EMPLOYEECONTRACT_FAIL,
  payload: error,
});